module.exports = {
      id: "plus-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#plus",
      toString: function () {
        return this.url;
      }
    }